/*
 * Copyright The OpenTelemetry Authors
 * SPDX-License-Identifier: Apache-2.0
 */
export class NoopLogger {
    emit(_logRecord) { }
    enabled() {
        return false;
    }
}
export const NOOP_LOGGER = new NoopLogger();
/**
 * Create a no-op Logger
 */
export function createNoopLogger() {
    return NOOP_LOGGER;
}
//# sourceMappingURL=NoopLogger.js.map